import { Instagram, Lock, Mail, Phone } from "lucide-react";
import { Logo } from "../components/Logo";
import { WhatsAppIcon } from "../components/WhatsAppFloat";
import { scrollToId } from "@/lib/scroll";
import { WHATSAPP_URL } from "@/lib/api";

const NAV = [
  { label: "Início", hash: "#inicio" },
  { label: "Como funciona", hash: "#como-funciona" },
  { label: "Serviços", hash: "#servicos" },
  { label: "Para imobiliárias", hash: "#imobiliarias" },
  { label: "Para proprietários", hash: "#para-quem" },
  { label: "Seja parceiro", hash: "#parceiros" },
  { label: "FAQ", hash: "#faq" },
  { label: "Contato", hash: "#contato" },
];

export const Footer = () => (
  <footer id="contato" className="bg-petrol pt-20 text-white" data-testid="main-footer">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid gap-12 pb-14 md:grid-cols-2 lg:grid-cols-[1.3fr_1fr_1.2fr]">
        <div>
          <Logo dark dataTestId="footer-logo" />
          <p className="mt-5 max-w-xs font-display text-lg font-semibold text-white/90">
            Problemas no imóvel? A gente resolve.
          </p>
          <p className="mt-3 max-w-xs text-sm leading-relaxed text-white/50">
            Tecnologia e operação para gestão de demandas imobiliárias — do chamado à conclusão.
          </p>
          <div className="mt-7 flex gap-3">
            <a
              href="https://www.instagram.com/resolvsc/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram da Resolv"
              data-testid="footer-social-instagram"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white/70 transition-colors duration-300 hover:border-brand hover:bg-brand hover:text-white"
            >
              <Instagram className="h-4.5 w-4.5" />
            </a>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp da Resolv"
              data-testid="footer-social-whatsapp"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white/70 transition-colors duration-300 hover:border-[#25D366] hover:bg-[#25D366] hover:text-white"
            >
              <WhatsAppIcon className="h-4.5 w-4.5" />
            </a>
          </div>
        </div>

        <div>
          <p className="font-mono text-[0.65rem] font-semibold uppercase tracking-[0.25em] text-brand-400">
            Navegação
          </p>
          <ul className="mt-5 grid grid-cols-1 gap-2.5">
            {NAV.map((link) => (
              <li key={link.hash + link.label}>
                <button
                  onClick={() => scrollToId(link.hash)}
                  data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-sm text-white/60 transition-colors duration-300 hover:text-white"
                >
                  {link.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-mono text-[0.65rem] font-semibold uppercase tracking-[0.25em] text-brand-400">
            Contato
          </p>
          <ul className="mt-5 space-y-4 text-sm text-white/60">
            <li className="flex items-center gap-3">
              <Phone className="h-4 w-4 shrink-0 text-brand-400" />
              (48) 99122-0068
            </li>
            <li className="flex items-center gap-3">
              <Mail className="h-4 w-4 shrink-0 text-brand-400" />
              contato@resolvsc.com.br
            </li>
          </ul>
        </div>
      </div>

      <div className="flex flex-col items-center justify-between gap-4 border-t border-white/10 py-7 sm:flex-row">
        <div className="text-center sm:text-left">
          <p className="text-[0.65rem] leading-relaxed text-white/30" data-testid="footer-legal-info">
            CNPJ 69.470.510/0001-29 · Rua Jomilda Camargo da Cunha, 293 - Kobrasol, São José/SC
          </p>
          <p className="mt-1.5 text-xs text-white/40">
            © 2026 RESOLV — Gestão de demandas imobiliárias. Todos os direitos reservados.
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
          <a
            href="/privacidade"
            data-testid="footer-link-privacidade"
            className="text-xs text-white/40 transition-colors duration-300 hover:text-white"
          >
            Política de Privacidade
          </a>
          <a
            href="/termos"
            data-testid="footer-link-termos"
            className="text-xs text-white/40 transition-colors duration-300 hover:text-white"
          >
            Termos de Uso
          </a>
          <a
            href="/admin"
            data-testid="footer-admin-link"
            className="inline-flex items-center gap-1.5 text-xs text-white/40 transition-colors duration-300 hover:text-white"
          >
            <Lock className="h-3 w-3" />
            Acesso interno
          </a>
        </div>
      </div>
    </div>
  </footer>
);
